import { SORT_ASC, SORT_DESC, SORT_PRICE_ASC, SORT_PRICE_DESC, SORT_POPULARITY_INDEX_DESC, SORT_PRODUCT_INDEX_ASC, SORT_PRODUCT_ABB_PRODUCT_NAME_LOCALIZED_ASC, SORT_PRODUCT_YEAR_DESC, } from '@yme/common/constants';
import { SearchSortingValues } from '@yme/components/SearchPage/hooks/constants';
import { useTranslation } from '@yme/services/i18n';
import { CLP_UNIT_SORTING, PLP_UNIT_SORTING, PLP_ACCESSORIES_SORTING, PLP_APPAREL_SORTING, PLP_ACCESSORIES_BLOOMREACH_SORTING, PLP_APPAREL_BLOOMREACH_SORTING, } from './constants';
export function useSortFilterOptions(props) {
    const { t } = useTranslation();
    const SORTING_OPTIONS_BY_DEFAULT = [
        {
            value: SORT_DESC,
            label: t('productsGrid_newestToOldest_option'),
            isValueDefault: true,
        },
        {
            value: SORT_ASC,
            label: t('productsGrid_oldestToNewest_option'),
        },
        {
            value: SORT_PRICE_ASC,
            label: t('productsGrid_priceLowToHigh_option'),
        },
        {
            value: SORT_PRICE_DESC,
            label: t('productsGrid_priceHighToLow_option'),
        },
    ];
    const SORTING_APPAREL_OPTION = [
        {
            value: SORT_POPULARITY_INDEX_DESC,
            label: t('productsGrid_popularityHighToLow_option'),
            isValueDefault: true,
        },
        {
            value: SORT_DESC,
            label: t('productsGrid_newestToOldest_option'),
        },
        {
            value: SORT_ASC,
            label: t('productsGrid_oldestToNewest_option'),
        },
        {
            value: SORT_PRICE_ASC,
            label: t('productsGrid_priceLowToHigh_option'),
        },
        {
            value: SORT_PRICE_DESC,
            label: t('productsGrid_priceHighToLow_option'),
        },
    ];
    const SORTING_APPAREL_BLOOMREACH_OPTION = [
        {
            value: SearchSortingValues.SORT_RECOMMENDED,
            label: t('productsGrid_recommended_option'),
            isValueDefault: true,
        },
        {
            value: SearchSortingValues.SORT_DESC,
            label: t('productsGrid_newestToOldest_option'),
        },
        {
            value: SearchSortingValues.SORT_ASC,
            label: t('productsGrid_oldestToNewest_option'),
        },
        {
            value: SearchSortingValues.SORT_PRICE_ASC,
            label: t('productsGrid_priceLowToHigh_option'),
        },
        {
            value: SearchSortingValues.SORT_PRICE_DESC,
            label: t('productsGrid_priceHighToLow_option'),
        },
    ];
    const SORTING_ACCESSORIES_OPTION = [
        {
            value: SORT_POPULARITY_INDEX_DESC,
            label: t('productsGrid_popularityHighToLow_option'),
        },
        {
            value: SORT_DESC,
            label: t('productsGrid_newestToOldest_option'),
            isValueDefault: true,
        },
        {
            value: SORT_ASC,
            label: t('productsGrid_oldestToNewest_option'),
        },
        {
            value: SORT_PRICE_ASC,
            label: t('productsGrid_priceLowToHigh_option'),
        },
        {
            value: SORT_PRICE_DESC,
            label: t('productsGrid_priceHighToLow_option'),
        },
    ];
    const SORTING_WITH_RECOMMENDED_OPTION = [
        {
            value: [
                SORT_PRODUCT_INDEX_ASC,
                SORT_PRODUCT_ABB_PRODUCT_NAME_LOCALIZED_ASC,
                SORT_PRODUCT_YEAR_DESC,
            ].join('|'),
            label: t('productsGrid_recommended_option'),
            isValueDefault: true,
        },
        {
            value: SORT_DESC,
            label: t('productsGrid_newestToOldest_option'),
        },
        {
            value: SORT_ASC,
            label: t('productsGrid_oldestToNewest_option'),
        },
        {
            value: SORT_PRICE_ASC,
            label: t('productsGrid_priceLowToHigh_option'),
        },
        {
            value: SORT_PRICE_DESC,
            label: t('productsGrid_priceHighToLow_option'),
        },
    ];
    const SORTING_ACCESSORIES_BLOOMREACH_OPTION = [
        {
            value: SearchSortingValues.SORT_RECOMMENDED,
            label: t('productsGrid_recommended_option'),
        },
        {
            value: SearchSortingValues.SORT_DESC,
            label: t('productsGrid_newestToOldest_option'),
            isValueDefault: true,
        },
        {
            value: SearchSortingValues.SORT_ASC,
            label: t('productsGrid_oldestToNewest_option'),
        },
        {
            value: SearchSortingValues.SORT_PRICE_ASC,
            label: t('productsGrid_priceLowToHigh_option'),
        },
        {
            value: SearchSortingValues.SORT_PRICE_DESC,
            label: t('productsGrid_priceHighToLow_option'),
        },
    ];
    const getFinallySortOptions = (type) => {
        switch (type) {
            case CLP_UNIT_SORTING:
                return SORTING_WITH_RECOMMENDED_OPTION;
            case PLP_UNIT_SORTING:
                return SORTING_WITH_RECOMMENDED_OPTION;
            case PLP_ACCESSORIES_SORTING:
                return SORTING_ACCESSORIES_OPTION;
            case PLP_APPAREL_SORTING:
                return SORTING_APPAREL_OPTION;
            case PLP_ACCESSORIES_BLOOMREACH_SORTING:
                return SORTING_ACCESSORIES_BLOOMREACH_OPTION;
            case PLP_APPAREL_BLOOMREACH_SORTING:
                return SORTING_APPAREL_BLOOMREACH_OPTION;
            default:
                return SORTING_OPTIONS_BY_DEFAULT;
        }
    };
    return {
        sortFilterOptions: getFinallySortOptions(props?.type),
    };
}
